export default "__VITE_ASSET__e25a1608__"